import { useTranslation } from 'react-i18next';
import { Sun, Moon, Monitor } from 'lucide-react';
import { useThemeStore, type Theme } from '../../stores/theme.js';
import { useFeatureFlag } from '../../lib/posthog.js';

const THEMES: { value: Theme; icon: React.ReactNode; labelKey: string }[] = [
  { value: 'light', icon: <Sun size={18} />, labelKey: 'appearance.theme_light' },
  { value: 'dark', icon: <Moon size={18} />, labelKey: 'appearance.theme_dark' },
  { value: 'system', icon: <Monitor size={18} />, labelKey: 'appearance.theme_system' },
];

export default function AppearanceSettings() {
  const { t } = useTranslation('settings');
  const { theme, setTheme } = useThemeStore();
  const appearanceEnabled = useFeatureFlag('appearance');

  if (!appearanceEnabled) {
    return (
      <div style={{ padding: 'var(--space-8)', textAlign: 'center', color: 'var(--color-text-muted)', fontSize: 'var(--text-sm)' }}>
        Appearance settings are not enabled for your account.
      </div>
    );
  }

  return (
    <div>
      <div style={{ marginBottom: 'var(--space-6)' }}>
        <h2 style={{ fontSize: 'var(--text-xl)', fontWeight: 'var(--font-semibold)', color: 'var(--color-text)', marginBottom: 'var(--space-1)' }}>
          {t('appearance.title')}
        </h2>
        <p style={{ fontSize: 'var(--text-sm)', color: 'var(--color-text-muted)' }}>
          {t('appearance.subtitle')}
        </p>
      </div>

      <div style={{
        background: 'var(--color-bg)', border: '1px solid var(--color-border)',
        borderRadius: 'var(--radius-lg)', padding: 'var(--space-5)',
      }}>
        <p style={{ fontSize: 'var(--text-sm)', fontWeight: 'var(--font-medium)', color: 'var(--color-text)', marginBottom: 'var(--space-3)' }}>
          {t('appearance.theme_label')}
        </p>
        <div style={{ display: 'flex', gap: 'var(--space-3)' }}>
          {THEMES.map(({ value, icon, labelKey }) => {
            const active = theme === value;
            return (
              <button
                key={value}
                onClick={() => setTheme(value)}
                style={{
                  display: 'flex', flexDirection: 'column', alignItems: 'center',
                  gap: 'var(--space-2)', padding: 'var(--space-4) var(--space-5)',
                  border: `2px solid ${active ? 'var(--color-brand)' : 'var(--color-border)'}`,
                  borderRadius: 'var(--radius-lg)', background: active ? 'var(--color-brand-pale)' : 'var(--color-bg)',
                  color: active ? 'var(--color-brand)' : 'var(--color-text-secondary)',
                  cursor: 'pointer', transition: 'all var(--duration-snap)',
                  minWidth: 90,
                }}
              >
                {icon}
                <span style={{ fontSize: 'var(--text-sm)', fontWeight: active ? 'var(--font-medium)' : undefined }}>
                  {t(labelKey)}
                </span>
              </button>
            );
          })}
        </div>
      </div>
    </div>
  );
}
